// src/services/dashboard/CityManager.js
import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/cities`;

const CityManager = {
  /**
   * GET /cities
   * returns: ApiResponse<List<CityDTO>>
   */
  async getAllCities() {
    const { data } = await axios.get(BASE_URL);
    // assuming your JSON is { responseData: [ { cityId, cityName, pincodes: [ … ] }, … ] }
    return data.responseData;
  },

      /**
   * Fetch only active cities along with their active pincodes.
   * GET /api/admin/cities/active
   * @returns {Promise<CityDTO[]>}
   */
      async getActiveCitiesWithPincodes() {
        const { data } = await axios.get(`${BASE_URL}/active`);
        return data.responseData;
      },
};



export default CityManager;
